// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.auth .branding {
  top: 0;
  left: 0;
  position: absolute;
  min-height: var(--header-height);
}

.auth .prompt__backdrop {
  background-color: transparent;
}

.auth .prompt__container {
  box-shadow: 0 0 15px 5px #777/*var(--button-bg-darker)*/;
}


/* FORM CONTAINER */

.auth .prompt__content {
  gap: 0;
}
.auth .prompt__content > * {
  text-align: center;
}

.auth .action {
  color: inherit;
  transition: 0.25s;
  text-decoration: none;
  
  margin: 5px 15px;
  align-self: flex-start;
}
.auth .checkbox {
  margin-bottom: 25px /* gap of 20px + regular 5px vertical margin */;
}

.auth a:hover, .auth a:focus {
  color: rgb(var(--accent-color));
}

.auth button.back__button {
  top: 0;
  left: 0;
  padding: 0;
  margin: 18px;
  position: absolute;
  
  transform: scale(1) !important;
  color: rgb(var(--accent-color));
  background-color: transparent !important;
}


/* Supported browsers */
.browsers {
  gap: 50px;
  padding: 50px;

  display: flex;
  justify-content: center;
}

.browsers img {
  -webkit-user-select: none;
          user-select: none;
  -webkit-user-drag: none;
}

.browsers > a {
  outline: 0;
  opacity: 0.9;
  transition: 0.15s;

  width: 100px;
  height: 100px;

  color: inherit;
  position: relative;
  text-decoration: none;
}
.browsers > a:hover, .browsers > a:focus-visible {
  opacity: 1;
  transform: scale(1.025);
}

.browsers > a::after {
  display: flex;
  overflow: hidden;
  width: fit-content;
  white-space: nowrap;

  top: 111%;
  left: 50%;
  position: absolute;

  visibility: hidden;
  transform-origin: top;
  transform: translateX(-50%) scale(0.9);
  transition: transform 0s 0.15s, opacity 0.15s;

  padding: 8px 12px;
  border-radius: var(--radius-small);
  background-color: var(--button-bg);
  
  content: attr(aria-label);
}
.browsers > a:hover::after, 
.browsers > a:focus-visible::after {
  visibility: unset;
  transition: 0.15s;
  transform: translateX(-50%) scale(1);
}
`, "",{"version":3,"sources":["webpack://./src/Components/Auth/Auth.css"],"names":[],"mappings":"AAAA;EACE,MAAM;EACN,OAAO;EACP,kBAAkB;EAClB,gCAAgC;AAClC;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,wDAAwD;AAC1D;;;AAGA,mBAAmB;;AAEnB;EACE,MAAM;AACR;AACA;EACE,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,qBAAqB;;EAErB,gBAAgB;EAChB,sBAAsB;AACxB;AACA;EACE,mEAAmE;AACrE;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,MAAM;EACN,OAAO;EACP,UAAU;EACV,YAAY;EACZ,kBAAkB;;EAElB,8BAA8B;EAC9B,+BAA+B;EAC/B,wCAAwC;AAC1C;;;AAGA,uBAAuB;AACvB;EACE,SAAS;EACT,aAAa;;EAEb,aAAa;EACb,uBAAuB;AACzB;;AAEA;EACE,yBAAiB;UAAjB,iBAAiB;EACjB,uBAAuB;AACzB;;AAEA;EACE,UAAU;EACV,YAAY;EACZ,iBAAiB;;EAEjB,YAAY;EACZ,aAAa;;EAEb,cAAc;EACd,kBAAkB;EAClB,qBAAqB;AACvB;AACA;EACE,UAAU;EACV,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;;EAEnB,SAAS;EACT,SAAS;EACT,kBAAkB;;EAElB,kBAAkB;EAClB,qBAAqB;EACrB,sCAAsC;EACtC,6CAA6C;;EAE7C,iBAAiB;EACjB,kCAAkC;EAClC,kCAAkC;;EAElC,yBAAyB;AAC3B;AACA;;EAEE,iBAAiB;EACjB,iBAAiB;EACjB,oCAAoC;AACtC","sourcesContent":[".auth .branding {\r\n  top: 0;\r\n  left: 0;\r\n  position: absolute;\r\n  min-height: var(--header-height);\r\n}\r\n\r\n.auth .prompt__backdrop {\r\n  background-color: transparent;\r\n}\r\n\r\n.auth .prompt__container {\r\n  box-shadow: 0 0 15px 5px #777/*var(--button-bg-darker)*/;\r\n}\r\n\r\n\r\n/* FORM CONTAINER */\r\n\r\n.auth .prompt__content {\r\n  gap: 0;\r\n}\r\n.auth .prompt__content > * {\r\n  text-align: center;\r\n}\r\n\r\n.auth .action {\r\n  color: inherit;\r\n  transition: 0.25s;\r\n  text-decoration: none;\r\n  \r\n  margin: 5px 15px;\r\n  align-self: flex-start;\r\n}\r\n.auth .checkbox {\r\n  margin-bottom: 25px /* gap of 20px + regular 5px vertical margin */;\r\n}\r\n\r\n.auth a:hover, .auth a:focus {\r\n  color: rgb(var(--accent-color));\r\n}\r\n\r\n.auth button.back__button {\r\n  top: 0;\r\n  left: 0;\r\n  padding: 0;\r\n  margin: 18px;\r\n  position: absolute;\r\n  \r\n  transform: scale(1) !important;\r\n  color: rgb(var(--accent-color));\r\n  background-color: transparent !important;\r\n}\r\n\r\n\r\n/* Supported browsers */\r\n.browsers {\r\n  gap: 50px;\r\n  padding: 50px;\r\n\r\n  display: flex;\r\n  justify-content: center;\r\n}\r\n\r\n.browsers img {\r\n  user-select: none;\r\n  -webkit-user-drag: none;\r\n}\r\n\r\n.browsers > a {\r\n  outline: 0;\r\n  opacity: 0.9;\r\n  transition: 0.15s;\r\n\r\n  width: 100px;\r\n  height: 100px;\r\n\r\n  color: inherit;\r\n  position: relative;\r\n  text-decoration: none;\r\n}\r\n.browsers > a:hover, .browsers > a:focus-visible {\r\n  opacity: 1;\r\n  transform: scale(1.025);\r\n}\r\n\r\n.browsers > a::after {\r\n  display: flex;\r\n  overflow: hidden;\r\n  width: fit-content;\r\n  white-space: nowrap;\r\n\r\n  top: 111%;\r\n  left: 50%;\r\n  position: absolute;\r\n\r\n  visibility: hidden;\r\n  transform-origin: top;\r\n  transform: translateX(-50%) scale(0.9);\r\n  transition: transform 0s 0.15s, opacity 0.15s;\r\n\r\n  padding: 8px 12px;\r\n  border-radius: var(--radius-small);\r\n  background-color: var(--button-bg);\r\n  \r\n  content: attr(aria-label);\r\n}\r\n.browsers > a:hover::after, \r\n.browsers > a:focus-visible::after {\r\n  visibility: unset;\r\n  transition: 0.15s;\r\n  transform: translateX(-50%) scale(1);\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
